<template>
  <div class="policy">
    <mt-header fixed title="恒信通隐私政策" class="title">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <div v-html="hasMobilePolicyText"> </div>
  </div>
</template>

<script>
/* global
    PUBLIC_POLICY_TEXT,
    PUBLIC_PRODUCT
*/

export default {
  name: 'Policy',
  data() {
    return {
      mobile: '（010-962909）',
      policyText: PUBLIC_POLICY_TEXT,
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
    };
  },
  computed: {
    hasMobilePolicyText() {
      if (this.product === 'cxplus' || this.product === 'cxpluszs') {
        return this.policyText.replace(/tmpCustomAppMobile/g, this.mobile);
      }
      return this.policyText.replace(/tmpCustomAppMobile/g, '');
    },
  },
  methods: {
    backClickHandler() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
